module.exports = __webpack_public_path__ + "static/media/12.5d8b92e1.JPG";